import { DialogActions, DialogContent, Typography, useMediaQuery, useTheme } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { Box } from '@mui/system';
import React, { memo } from 'react';
import { PmiDialog } from 'shell/components/shared/dialog';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  rePrint: () => void;
  onConfirm: () => void;
}

function PrintSuccessModalDeclaration({
  isOpen,
  onClose,
  rePrint,
  onConfirm,
}: SuccessModalProps): React.ReactElement {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={onClose}
      aria-labelledby="close-modal"
      aria-describedby="close-modal"
    >
      <DialogContent style={{ padding: '30px 24px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography gutterBottom component="h2">
            La stampa del documento è stata effettuata con successo?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="cdmBrand" type="button" onClick={onConfirm}>
          Conferma
        </PmiButton>
        <PmiButton variant="outlined" color="primary" type="button" onClick={rePrint}>
          Ristampa
        </PmiButton>
        <PmiButton variant="contained" color="cdmBrand" type="button" onClick={onClose}>
          Annulla
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
}

PrintSuccessModalDeclaration.displayName = 'Print Success Modal component';
export default memo(PrintSuccessModalDeclaration);
